/*-------------------------------------------------*/
/* =  Reviews OWL carousel
/*-------------------------------------------------*/

window.renderReviewsCarousel = (item) => {

    const carousel = item.find('.owl-carousel'),
        dataNum = item.find('.owl-carousel').attr('data-num');
    let dataNum2,
        dataNum3;

    if (dataNum === 1) {
        dataNum2 = 1;
        dataNum3 = 1;
    } else if (dataNum === 2) {
        dataNum2 = 1;
        dataNum3 = dataNum - 1;
    } else if (dataNum > 3) {
        dataNum2 = dataNum - 2;
        dataNum3 = dataNum - 3;
    } else {
        dataNum2 = dataNum - 1;
        dataNum3 = dataNum - 2;
    }

    carousel.owlCarousel({
        autoPlay: 10000,
        navigation: false,
        loop: false,
        dots: false,
        nav: true,
        lazyLoad: true,
        navText: ["<svg class='es-nav-arrow' width='1em' height=\"1em\" viewBox=\"0 0 320 512\" fill=\"currentColor\"><path d=\"M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z\"/></svg>", "<svg class='es-nav-arrow' width='1em' height=\"1em\" viewBox=\"0 0 320 512\" fill=\"currentColor\"><path d=\"M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z\"/></svg>"],
        responsive: {
            0: {
                items: dataNum3
            },
            768: {
                items: dataNum2
            },
            960: {
                items: dataNum2
            },
            1200: {
                items: dataNum
            }
        }
    });
}

const owlWrap = $('.reviews .owl-wrapper, .reviews .owl-scroller');

if (owlWrap.length > 0) {
    if (jQuery().owlCarousel) {
        owlWrap.each(function () {
            renderReviewsCarousel($(this))
        });
    }
}
